"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8283],{

/***/ "./src/components/Elements/Avatar/DisplayAvatar.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/boring-avatars/build/index.js");
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(boring_avatars__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/avatar/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _data_AvatarData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/data/AvatarData.ts");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/config/index.ts");
/* harmony import */ var _services_profile_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/services/profile/utils.ts");
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");










const DisplayAvatar = (param)=>{
    let { address , svgProps , avatarIPFS , wrapperProps , size =26 , alt , ...rest } = param;
    const [avatar] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__/* .useENSData */ .L)(address);
    const { avatar: fetchedAvatarIPFS , setAccount  } = (0,_services_profile_utils__WEBPACK_IMPORTED_MODULE_5__/* .useUserProfileData */ .Cf)(_services_profile_utils__WEBPACK_IMPORTED_MODULE_5__/* .UserProfileFetchOptions.ONLY_AVATAR */ .Ky.ONLY_AVATAR);
    let content = null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (address && !avatarIPFS) {
            setAccount(address);
        }
    }, [
        address,
        avatarIPFS,
        setAccount
    ]);
    if (avatarIPFS || fetchedAvatarIPFS) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
            imgBoxSize: size,
            src: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(avatarIPFS || fetchedAvatarIPFS),
            borderRadius: "full",
            ...rest,
            alt: alt || "Avatar"
        });
    } else if (avatar) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Avatar */ .qE, {
            boxSize: "".concat(size, "px"),
            src: avatar,
            name: alt,
            ...rest
        });
    } else if (address && !avatar) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((boring_avatars__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: size,
            variant: "pixel",
            name: address,
            colors: _data_AvatarData__WEBPACK_IMPORTED_MODULE_8__/* .AvatarColorArray */ .M
        });
    } else {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO, {
            cursor: "pointer",
            fontSize: size,
            color: "gray.600",
            _dark: {
                color: "gray.200"
            },
            fontWeight: 600,
            as: react_icons_ri__WEBPACK_IMPORTED_MODULE_10__/* .RiUserLine */ .s60,
            title: alt
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Center */ .M5, {
        ...wrapperProps,
        sx: {
            svg: {
                ...svgProps
            }
        },
        borderRadius: "full",
        children: content
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayAvatar);


/***/ }),

/***/ "./src/components/Elements/Image/Image.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* unused harmony export cfLoader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/image.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const BASE_URL = "https://iq.wiki";
const cfLoader = (param)=>{
    let { src , width , quality  } = param;
    const params = [
        "width=".concat(width)
    ];
    if (quality) params.push("quality=".concat(quality));
    const paramsString = params.join(",");
    return "".concat(BASE_URL, "/cdn-cgi/image/").concat(paramsString, "/").concat(normalizeSrc(src));
};
const normalizeSrc = (src)=>{
    return src.startsWith("/") ? src.slice(1) : src;
};
const Image = (param)=>/*#__PURE__*/ {
    let { src , alt , priority , placeholder , blurDataURL , hideOnError , sizes , objectFit ="cover" , imgBoxSize , imgW , imgH , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        h: "".concat(imgBoxSize || imgH, "px"),
        w: "".concat(imgBoxSize || imgW, "px"),
        ...rest,
        overflow: "hidden",
        position: "relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            quality: 95,
            style: {
                objectFit,
                objectPosition: "top",
                width: "100%",
                height: "100%"
            },
            loader: typeof src === "string" && src.startsWith("http") ? cfLoader : undefined,
            fill: !(imgW && imgH) || !imgBoxSize,
            src: src,
            alt: alt,
            onError: (e)=>{
                if (hideOnError) {
                    e.currentTarget.style.visibility = "hidden";
                }
            },
            priority: priority,
            sizes: sizes,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            loading: priority ? "eager" : "lazy",
            width: imgBoxSize || imgW,
            height: imgBoxSize || imgH
        })
    });
};


/***/ }),

/***/ "./src/components/Elements/LinkElements/LinkButton.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _LinkWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/LinkElements/LinkWrapper.tsx");




const LinkButton = (param)=>{
    let { href , prefetch , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkWrapper__WEBPACK_IMPORTED_MODULE_2__/* .LinkWrapper */ .g, {
        href: href,
        prefetch: prefetch,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
            as: "a",
            ...props,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LinkButton);


/***/ }),

/***/ "./src/components/Elements/index.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qE": function() { return /* reexport */ DisplayAvatar/* default */.Z; },
  "fh": function() { return /* reexport */ Dropzone_Dropzone; },
  "aG": function() { return /* reexport */ ImageInput_ImageInput; },
  "rU": function() { return /* reexport */ Link/* default */.Z; },
  "Qj": function() { return /* reexport */ LinkButton/* default */.Z; },
  "TR": function() { return /* reexport */ Logo/* default */.Z; },
  "u_": function() { return /* reexport */ Modal_Modal; },
  "QZ": function() { return /* reexport */ SocialIcon_SocialIcon; }
});

// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkButton.tsx
var LinkButton = __webpack_require__("./src/components/Elements/LinkElements/LinkButton.tsx");
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/toast/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__("./node_modules/react-dropzone/dist/es/index.js");
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__("./node_modules/wagmi/dist/index.js");
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__("./src/config/index.ts");
// EXTERNAL MODULE: ./src/store/slices/wiki.slice.ts
var wiki_slice = __webpack_require__("./src/store/slices/wiki.slice.ts");
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var react_redux_es = __webpack_require__("./node_modules/react-redux/es/index.js");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js
var tooltip_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tooltip/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Elements/Image/EditorMainImageWrapper.tsx





const EditorMainImageWrapper = (param)=>{
    let { imageUploading , removeImage , cropImage , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        pos: "relative",
        direction: "column",
        w: "full",
        h: "full",
        justify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* ButtonGroup */.hE, {
                isAttached: true,
                colorScheme: "gray.600",
                pos: "absolute",
                top: 3,
                left: 3,
                zIndex: 1,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                        label: "Delete Image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                            onClick: removeImage,
                            "aria-label": "Remove image",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiDeleteBinLine */.qy0, {}),
                            variant: "outline",
                            background: "whiteAlpha.800",
                            color: "blackAlpha.700",
                            sx: {
                                "&:hover, &:focus, &:active": {
                                    background: "whiteAlpha.800"
                                }
                            },
                            size: "sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                        label: "Crop image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                            onClick: cropImage,
                            "aria-label": "Remove image",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiCropLine */.Lu8, {}),
                            variant: "outline",
                            background: "whiteAlpha.800",
                            color: "blackAlpha.700",
                            sx: {
                                "&:hover, &:focus, &:active": {
                                    background: "whiteAlpha.800"
                                }
                            },
                            size: "sm"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                children: children
            }),
            imageUploading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                pos: "absolute",
                bottom: "4",
                right: "4",
                bgColor: "whiteAlpha.800",
                py: 1,
                px: 3,
                borderRadius: "sm",
                color: "black",
                borderWidth: "1px",
                borderColor: "blackAlpha.700",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                            size: "xs"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            fontSize: "sm",
                            children: "Uploading image..."
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.min.js
var ReactCrop_min = __webpack_require__("./node_modules/react-image-crop/dist/ReactCrop.min.js");
var ReactCrop_min_default = /*#__PURE__*/__webpack_require__.n(ReactCrop_min);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 52 modules
var modal_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/modal/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/image/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.css
var ReactCrop = __webpack_require__("./node_modules/react-image-crop/dist/ReactCrop.css");
;// CONCATENATED MODULE: ./src/components/Elements/Image/ImageCrop.tsx
/* eslint-disable @next/next/no-img-element */ 






const centerAspectCrop = (mediaWidth, mediaHeight, aspect)=>{
    return (0,ReactCrop_min.centerCrop)((0,ReactCrop_min.makeAspectCrop)({
        unit: "px",
        width: mediaWidth * 0.8
    }, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
};
const canvasPreview = (image, canvas, crop)=>{
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        throw new Error("No 2d context");
    }
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const pixelRatio = window.devicePixelRatio;
    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);
    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";
    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;
    ctx.save();
    ctx.translate(-cropX, -cropY);
    ctx.translate(centerX, centerY);
    ctx.translate(-centerX, -centerY);
    ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);
    ctx.restore();
};
const ImageCrop = (param)=>{
    let { imageToCrop , onClose , setImage , setDisplayImage  } = param;
    const [crop, setCrop] = (0,react.useState)();
    const previewCropRef = (0,react.useRef)(null);
    const [saving, setSaving] = (0,react.useState)(false);
    const [initialDisplayImageUrl, setInitialDisplayImageUrl] = (0,react.useState)();
    const [isInitialImageLoaded, setIsInitialImageLoaded] = (0,react.useState)(false);
    const toast = (0,index_esm/* useToast */.pm)();
    const onImageLoad = (e)=>{
        if (crop) return;
        const { width , height  } = e.currentTarget;
        setCrop(centerAspectCrop(width, height, Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag));
        setIsInitialImageLoaded(true);
    };
    const handleImageCrop = ()=>{
        if (!previewCropRef.current || !crop) return;
        setSaving(true);
        const canvas = document.createElement("canvas");
        canvasPreview(previewCropRef.current, canvas, crop);
        canvas.toBlob((b)=>{
            if (b) {
                const reader = new FileReader();
                reader.readAsArrayBuffer(b);
                reader.onload = ()=>{
                    if (reader.result) {
                        setDisplayImage(URL.createObjectURL(b));
                        setImage("image", reader.result);
                        setSaving(false);
                        onClose();
                    }
                };
            } else {
                if (!toast.isActive("image-crop-error")) {
                    toast({
                        id: "image-crop-error",
                        title: "Cannot crop image",
                        description: "Try selecting a different area of image or upload a new image",
                        status: "error",
                        duration: 2000,
                        isClosable: true
                    });
                }
                setSaving(false);
            }
        }, "image/jpeg");
    };
    (0,react.useEffect)(()=>{
        if (typeof imageToCrop !== "string") {
            setTimeout(()=>{
                const url = URL.createObjectURL(new Blob([
                    imageToCrop
                ], {
                    type: "image/jpeg"
                }));
                setInitialDisplayImageUrl(url);
            }, 500);
        } else {
            setInitialDisplayImageUrl(imageToCrop);
        }
    }, [
        imageToCrop
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isCentered: true,
        isOpen: imageToCrop !== null,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                w: "min(95vw, 500px)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                        pb: 0,
                        children: "Crop Image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                mb: 4,
                                children: "Drag the rectangle to adjust the crop area and click the crop and save button to save the image."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                isLoaded: isInitialImageLoaded,
                                w: "100%",
                                h: "300px",
                                bgColor: "black",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                    h: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ReactCrop_min_default()), {
                                        aspect: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                                        crop: crop,
                                        onChange: (c)=>setCrop(c),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                            crossOrigin: "anonymous",
                                            maxH: "300px !important",
                                            objectFit: "contain",
                                            ref: previewCropRef,
                                            src: initialDisplayImageUrl,
                                            onLoad: onImageLoad
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            isLoading: saving,
                            disabled: !crop,
                            loadingText: "Saving...",
                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiCropLine */.Lu8, {}),
                            colorScheme: "brand",
                            mr: 3,
                            onClick: handleImageCrop,
                            children: "Crop and Save"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Image_ImageCrop = (ImageCrop);

;// CONCATENATED MODULE: ./src/components/Elements/Dropzone/Dropzone.tsx
/* provided dependency */ var Buffer = __webpack_require__("./node_modules/buffer/index.js")["lW"];












const Dropzone = (param)=>{
    let { imageUploading , dropZoneActions , dropzonePlaceHolderTitle , dropzonePlaceHolderSize , aspectRatio , mediaModal  } = param;
    const [paths, setPaths] = (0,react.useState)([]);
    const [toCropImg, setToCropImg] = (0,react.useState)(null);
    const toast = (0,index_esm/* useToast */.pm)();
    const dispatch = (0,react_redux_es/* useDispatch */.I0)();
    const { address: userAddress  } = (0,dist/* useAccount */.mA)();
    const { setHideImageInput , isToResetImage , setImage , deleteImage , initialImage , showFetchedImage , textType  } = dropZoneActions;
    const onDrop = (0,react.useCallback)((acceptedFiles)=>{
        setPaths(acceptedFiles.map((file)=>URL.createObjectURL(file)));
        acceptedFiles.forEach((f)=>{
            const reader = new FileReader();
            reader.onload = ()=>{
                const binaryStr = Buffer.from(reader.result);
                // validate image
                const fileSize = binaryStr.byteLength / 1024 ** 2;
                if (fileSize > 10) {
                    toast({
                        title: "File size is larger than 10mb",
                        status: "error",
                        duration: 3000
                    });
                    if (setHideImageInput) setHideImageInput(false);
                    setPaths([]);
                    return;
                }
                // set image to state
                if (mediaModal) {
                    setImage(f.name, binaryStr);
                } else {
                    setToCropImg(binaryStr);
                }
            };
            reader.readAsArrayBuffer(f);
        });
        if (setHideImageInput) {
            setHideImageInput(true);
        }
    }, [
        mediaModal,
        setHideImageInput,
        setImage,
        toast
    ]);
    const { getRootProps , getInputProps , isDragActive  } = (0,es/* useDropzone */.uI)({
        onDrop,
        maxFiles: 1,
        accept: "image/jpeg, image/png, image/jpg, image/webp"
    });
    (0,react.useEffect)(()=>{
        if (initialImage) {
            const path = "".concat(config/* default.pinataBaseUrl */.Z.pinataBaseUrl).concat(initialImage);
            if (setHideImageInput) {
                setHideImageInput(true);
            }
            setPaths([
                path
            ]);
        }
    }, [
        initialImage,
        setHideImageInput
    ]);
    (0,react.useEffect)(()=>{
        if (isToResetImage) {
            var ref;
            const draftWiki = (0,wiki_slice/* getDraftFromLocalStorage */.ON)();
            if (!draftWiki || (draftWiki === null || draftWiki === void 0 ? void 0 : (ref = draftWiki.image) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                dispatch({
                    type: "wiki/setInitialWikiState",
                    payload: {
                        image: undefined
                    }
                });
                if (setHideImageInput) setHideImageInput(false);
                setPaths([]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isToResetImage,
        setHideImageInput
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            toCropImg && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ImageCrop, {
                imageToCrop: toCropImg,
                onClose: ()=>setToCropImg(null),
                setImage: setImage,
                setDisplayImage: (img)=>setPaths([
                        img
                    ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                children: paths.length === 0 || !showFetchedImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                    ratio: aspectRatio || Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                        display: "flex",
                        padding: "10px",
                        border: "1px",
                        borderColor: "borderColor",
                        borderStyle: "dashed",
                        borderRadius: "5px",
                        justifyContent: "center",
                        alignItems: "center",
                        h: "full",
                        _hover: {
                            boxShadow: "md",
                            borderColor: "brand.400"
                        },
                        ...getRootProps(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                disabled: !userAddress,
                                ...getInputProps()
                            }),
                            isDragActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                textAlign: "center",
                                children: "Drop the files here ..."
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                px: "8",
                                mb: !showFetchedImage ? "10" : "1",
                                children: dropzonePlaceHolderTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                            textAlign: "center",
                                            color: "wikiDropzoneText",
                                            fontSize: "md",
                                            children: dropzonePlaceHolderTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                            textAlign: "center",
                                            fontSize: "sm",
                                            color: "wikiDropzoneText",
                                            children: dropzonePlaceHolderSize
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                            textAlign: "center",
                                            color: "wikiDropzoneText",
                                            children: [
                                                "Drag and drop a ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: textType
                                                }),
                                                ", or click to select."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                            textAlign: "center",
                                            color: "wikiDropzoneText",
                                            fontWeight: "bold",
                                            children: "(10mb max)"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: showFetchedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorMainImageWrapper, {
                        imageUploading: imageUploading,
                        cropImage: ()=>setToCropImg(paths[0]),
                        removeImage: ()=>{
                            setPaths([]);
                            if (setHideImageInput && deleteImage) {
                                setHideImageInput(false);
                                deleteImage();
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            objectFit: "cover",
                            h: "255px",
                            w: "full",
                            borderRadius: 4,
                            priority: true,
                            overflow: "hidden",
                            src: paths[0],
                            alt: "Input"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Dropzone_Dropzone = (Dropzone);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/input/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
;// CONCATENATED MODULE: ./src/components/Elements/ImageInput/ImageInput.tsx
/* eslint-disable no-useless-escape */ 






const ImageInput = (param)=>{
    let { imageUploading , setHideDropzone , setImage , deleteImage , showFetchedImage , modalUpload  } = param;
    const [imgSrc, setImageSrc] = (0,react.useState)();
    const [toCropImg, setToCropImg] = (0,react.useState)();
    const toast = (0,index_esm/* useToast */.pm)();
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const dispatch = (0,react_redux_es/* useDispatch */.I0)();
    const removeImage = (0,react.useCallback)(()=>{
        setImageSrc(undefined);
        if (deleteImage && setHideDropzone) {
            setHideDropzone(false);
            deleteImage();
        }
    }, [
        deleteImage,
        setHideDropzone
    ]);
    const linkRecognizer = (url)=>{
        const validYTLinkReg = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
        const validLinkReg = /^(http|https):\/\//;
        if (!validLinkReg.test(url)) {
            return {
                type: null
            };
        }
        if (/(https?:\/\/)?(www.)?youtu(be\.com|.be)\//.test(url)) {
            const videoCode = url.match(validYTLinkReg);
            return {
                type: "youtube",
                value: videoCode === null || videoCode === void 0 ? void 0 : videoCode[1]
            };
        }
        return {
            type: "imageURL"
        };
    };
    const tryUploadImg = async (url)=>{
        const imageUrl = url;
        const FullUrl = "https://everipedia-cors.vercel.app/?url=".concat(imageUrl);
        const response = await fetch(FullUrl, {
            method: "GET",
            headers: {}
        });
        if (response.status !== 200) {
            removeImage();
            toast({
                title: "Image could not be fetched. Ensure you have the right link",
                status: "error",
                duration: 2000
            });
            return;
        }
        const data = await response.arrayBuffer();
        if (modalUpload) {
            setImage("image", data);
        } else setToCropImg(data);
        if (!showFetchedImage) {
            setImageSrc("");
        }
        toast({
            title: "Image successfully Fetched",
            status: "success",
            duration: 2000
        });
    };
    const catchImageUploadError = ()=>{
        removeImage();
        toast({
            title: "Image could not be fetched. Ensure you have the right link",
            status: "error",
            duration: 2000
        });
    };
    const handleOnImageInputChanges = async (event)=>{
        const url = event.target.value;
        const urlType = linkRecognizer(url);
        if (!urlType.type) {
            setImageSrc(undefined);
            toast({
                title: "Paste a valid image URL",
                status: "error",
                duration: 3000
            });
            return;
        }
        if (urlType.type === "youtube") {
            const videoID = urlType === null || urlType === void 0 ? void 0 : urlType.value;
            dispatch({
                type: "wiki/addMedia",
                payload: {
                    name: videoID,
                    size: 0,
                    id: "https://www.youtube.com/watch?v=".concat(videoID),
                    source: "YOUTUBE"
                }
            });
        }
        setImageSrc(event.target.value);
        if (setHideDropzone) {
            setHideDropzone(true);
        }
        if (urlType.type === "imageURL") {
            try {
                tryUploadImg(url);
            } catch (_error) {
                catchImageUploadError();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            toCropImg && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ImageCrop, {
                imageToCrop: toCropImg,
                setImage: setImage,
                onClose: ()=>setToCropImg(null),
                setDisplayImage: setImageSrc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                mt: imgSrc && showFetchedImage ? 0 : -20,
                mb: imgSrc && showFetchedImage ? 0 : 7,
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                children: imgSrc && showFetchedImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorMainImageWrapper, {
                    imageUploading: imageUploading,
                    cropImage: ()=>setToCropImg(imgSrc),
                    removeImage: removeImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                        objectFit: "cover",
                        h: "255px",
                        w: "full",
                        borderRadius: 4,
                        overflow: "hidden",
                        bgColor: "dimColor",
                        src: imgSrc,
                        alt: "Input"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                    w: "90%",
                    textAlign: "center",
                    value: "",
                    color: "wikiDropzoneText",
                    onChange: handleOnImageInputChanges,
                    placeholder: modalUpload ? "".concat(t("pasteModalMainImgLabel")) : "".concat(t("pasteMainImgLabel")),
                    _placeholder: {
                        color: "wikiDropzoneText"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var ImageInput_ImageInput = (ImageInput);

// EXTERNAL MODULE: ./src/components/Elements/LinkElements/Link.tsx
var Link = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");
// EXTERNAL MODULE: ./src/components/Elements/Logo/Logo.tsx
var Logo = __webpack_require__("./src/components/Elements/Logo/Logo.tsx");
;// CONCATENATED MODULE: ./src/components/Elements/Modal/Modal.tsx



const Modal = (param)=>/*#__PURE__*/ {
    let { children , title , onClose , enableBottomCloseButton =true , SecondaryButton , ...rest } = param;
    return (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        onClose: onClose,
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                m: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                        gap: 5,
                        children: [
                            enableBottomCloseButton === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                onClick: onClose,
                                children: "Close"
                            }),
                            SecondaryButton || null
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Modal_Modal = (Modal);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Elements/SocialIcon/SocialIcon.tsx




const SocialIcon = (param)=>/*#__PURE__*/ {
    let { Icon , link  } = param;
    return (0,jsx_runtime.jsxs)(Link/* default */.Z, {
        target: "_blank",
        href: link,
        _hover: {
            textDecoration: "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                srOnly: true,
                children: link
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                size: "md",
                variant: "social",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        srOnly: true,
                        children: link
                    }),
                    Icon
                ]
            })
        ]
    });
};
/* harmony default export */ var SocialIcon_SocialIcon = (SocialIcon);

;// CONCATENATED MODULE: ./src/components/Elements/index.ts










/***/ }),

/***/ "./src/data/AvatarData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ AvatarColorArray; }
/* harmony export */ });
const AvatarColorArray = [
    "#92A1C6",
    "#146A7C",
    "#F0AB3D",
    "#C271B4",
    "#C20D90"
];


/***/ }),

/***/ "./src/data/Constants.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ITEM_PER_PAGE; },
/* harmony export */   "L": function() { return /* binding */ WIKI_METADATA_VALUE_LIMIT; },
/* harmony export */   "Nf": function() { return /* binding */ FETCH_DELAY_TIME; },
/* harmony export */   "Vl": function() { return /* binding */ CATEGORY_DESCRIPTION_WORD_LIMIT; },
/* harmony export */   "a": function() { return /* binding */ WIKI_SUMMARY_LIMIT; },
/* harmony export */   "ag": function() { return /* binding */ WIKI_IMAGE_ASPECT_RATIO; },
/* harmony export */   "ft": function() { return /* binding */ MEDIA_POST_DEFAULT_ID; },
/* harmony export */   "hj": function() { return /* binding */ WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL; },
/* harmony export */   "xh": function() { return /* binding */ IMAGE_BOX_SIZE; }
/* harmony export */ });
/* unused harmony exports WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS, GPT3_COST_PER_1K_TOKENS, GPT3_MAX_TRIES */
const ITEM_PER_PAGE = 12;
const FETCH_DELAY_TIME = 3000;
const CATEGORY_DESCRIPTION_WORD_LIMIT = 200;
const MEDIA_POST_DEFAULT_ID = "UPLOADING_ID";
const WIKI_IMAGE_ASPECT_RATIO = 4 / 3;
const WIKI_METADATA_VALUE_LIMIT = 255;
const WIKI_SUMMARY_LIMIT = 255;
const WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL = 10 * 60 * 1000 // 10 Mins
;
const WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS = 5;
const GPT3_COST_PER_1K_TOKENS = 0.02;
const GPT3_MAX_TRIES = 3;
const IMAGE_BOX_SIZE = 150;


/***/ }),

/***/ "./src/hooks/useENSData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useENSData; }
/* harmony export */ });
/* harmony import */ var _services_ens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/services/ens/index.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const useENSData = (address, skip)=>{
    const [avatar, setAvatar] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [displayName, setDisplayName] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [loading, setLoading] = react__WEBPACK_IMPORTED_MODULE_2__.useState(false);
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        if (!address || skip) return;
        const fetchEnsData = async ()=>{
            setLoading(true);
            const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(_services_ens__WEBPACK_IMPORTED_MODULE_0__/* .getEns.initiate */ .gS.initiate(address.toLowerCase()));
            if (data) {
                setAvatar(data.avatar);
                setDisplayName((p)=>data.displayName.endsWith(".eth") ? data.displayName : p);
            }
            setLoading(false);
        };
        fetchEnsData();
    }, [
        address,
        skip
    ]);
    return [
        avatar,
        displayName,
        loading
    ];
};


/***/ }),

/***/ "./src/services/profile/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ useUserProfileData; },
/* harmony export */   "Ky": function() { return /* binding */ UserProfileFetchOptions; },
/* harmony export */   "oN": function() { return /* binding */ isUserNameTaken; }
/* harmony export */ });
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/services/profile/index.tsx");



var UserProfileFetchOptions;
(function(UserProfileFetchOptions) {
    UserProfileFetchOptions[UserProfileFetchOptions["WITH_ALL_SETTINGS"] = 0] = "WITH_ALL_SETTINGS";
    UserProfileFetchOptions[UserProfileFetchOptions["ONLY_EMAIL"] = 1] = "ONLY_EMAIL";
    UserProfileFetchOptions[UserProfileFetchOptions["ONLY_AVATAR"] = 2] = "ONLY_AVATAR";
    UserProfileFetchOptions[UserProfileFetchOptions["USER_PROFILE"] = 3] = "USER_PROFILE";
})(UserProfileFetchOptions || (UserProfileFetchOptions = {}));
const useUserProfileData = (options, address)=>{
    const [profileData, setProfileData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [avatar, setAvatar] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [account, setAccount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(address || "");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!account) return;
        const fetchSettings = async ()=>{
            try {
                if (options === UserProfileFetchOptions.WITH_ALL_SETTINGS) {
                    const { data: fetchedProfileData  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserSettings.initiate */ .nS.initiate(account));
                    setProfileData(fetchedProfileData);
                } else if (options === UserProfileFetchOptions.ONLY_AVATAR) {
                    const { data: fetchedUserProfileAvatar  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserAvatar.initiate */ .Dm.initiate(account));
                    setAvatar(fetchedUserProfileAvatar);
                } else if (options === UserProfileFetchOptions.ONLY_EMAIL) {
                    const { data: fetchedProfileData1  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserEmail.initiate */ .gV.initiate(account));
                    setProfileData(fetchedProfileData1);
                } else if (options === UserProfileFetchOptions.USER_PROFILE) {
                    const { data: fetchedProfileData2  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserProfile.initiate */ .et.initiate(account));
                    setProfileData(fetchedProfileData2);
                }
                setLoading(false);
            } catch (_err) {
                setLoading(false);
            }
        };
        fetchSettings();
    }, [
        account,
        options
    ]);
    return {
        setAccount,
        profileData,
        loading,
        avatar
    };
};
const isUserNameTaken = async (username)=>{
    const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUsernameTaken.initiate */ .l4.initiate(username));
    return data;
};


/***/ })

}]);